import React from 'react';
import { Box } from '@mui/material';
import logoImage from '/src/assets/clodexa-logo.png';

const Header = () => {
  return (
    <Box className="flex items-center gap-1">
      <div>
        <img 
          src={logoImage}
          alt="Clodexa"
          className="h-[24px] w-[24px] rounded-full"
        />
      </div>
      <span className="text-black text-[16px] font-normal tracking-wider ">
        Clodexa
      </span>
    </Box>
  );
};

export default Header; 